import React, { useContext, useState } from "react";
import { ThemeContext } from 'styled-components'
import styled from "styled-components";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from '../../../dashboard-context'
import RefreshIcon from "../../../../../images/refresh.png";
import { getDaysSinceWeighIn, hostDateToString, dateStringAddDays } from "../../inspect/util";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as ArrowUp} from "../../../../../images/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../images/arrow-down.svg";
import { getAttentionSettings, AlertSettings } from './alert-table-settings'
import { MISSED_TRACKING_LABELS } from "./missed-tracking-labels";
import { Row, Action } from '../../../../../components/action-button'
import SearchIcon from '@material-ui/icons/Search';
import moment from "moment";

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
    maxWidth: 500,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TableTitle = styled.h2`
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`;

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 280px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`;

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;

  td, th {
    font-size: .9rem;
  }
`;

const TableHead = styled.thead`
  color: #fff;
`;

const TableBody = styled.tbody``;

const TableHeadRow = styled.tr``;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-weight: 400;
  /* min-width: ${(props) => (props.bigWidth ? "180px" : "100px")}; */
  padding: 8px 12px;
  position: sticky;
  text-align: left;
  top: 0;
  white-space: nowrap;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) => (props.color ? props.color : "unset")};
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  padding: 8px 12px;
  text-align: left;
  white-space: nowrap;
`;

const NameCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) => (props.nearPeriod ? "#FFF" : "unset")};
  font-family: ${(props) => props.theme.font.secondary};
  font-weight: 400;
  padding: 8px 12px;
  text-align: left;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  img {
    margin-right: 2px;
  }
  span {
    background: ${(props) => (props.nearPeriod ? "#e129a3" : "none")};
    border-radius: 100px;
    padding: ${(props) => (props.nearPeriod ? "4px 10px" : "none")};
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const NameText = styled.p`
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const LastCheckinCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) =>
    props.tracking
      ? props.tracking === "Incomplete"
        ? "#dc544a"
        : props.tracking === "Complete"
        ? "#4cb050"
        : "#f4b300"
      : "unset"};
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  padding: 4px 8px;
  position: relative;
  padding-top: 6px;
  text-align: left;
  white-space: nowrap;
`;

const LastCheckinPill = styled.div`
  background: #dadada;
  border-radius: 100px;
  color: #848484;
  display: inline-block;
  padding: 2px 12px;
`;

const LastCheckinContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  span {
    text-transform: capitalize;
    margin-left: 4px;
  }

  p {
    margin-left: 4px;
  }
`;

const Bar = styled.div`
  background: #f0f0f0;
  border-radius: 100px;
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  height: 25px;
  width: 10px;
  margin: 0 4px 0px 0px;

  >div {
    background: ${(props) => (props.color ? props.color : "unset")};
    border-radius: 100px;
    content: "";
    width: 10px;
    height: ${(props) => (props.height ? `${props.height}%` : "unset")};
  }
`;

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ImprovingText = styled.span`
  font-size: .6rem;
  text-transform: none !important;
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
`;

const LastCheckinDate = styled.p`
  font-size: 0.7rem;
  font-weight: 500;
  color: #333333;
  margin: 0;
  position: absolute;
  top: 2px;
  left: 32px;
`;

const AccountsTable = (props) => {
  const { user } = useContext(AuthContext);
  const theme = useContext(ThemeContext)
  const [sortType, setSortType] = useState({type: 'name', reverse: false});
  const { filterGroupID, clientsTrainerID } = React.useContext(DashboardContext);
  const attentionSettings = getAttentionSettings(user.attention_settings)

  const isAlert = (data) => {
    const { days, claimed, untracked_day_indices, report_date, last_progress_summary, check_in_type, vacation_mode_info, vacation_mode } = data;
    const threshold_untracked_day_index = untracked_day_indices.length < attentionSettings.missedtracking ? null : untracked_day_indices[attentionSettings.missedtracking - 1];
    const daysSinceCheckin = getDaysSinceWeighIn(report_date);

    let isPaused = vacation_mode && !vacation_mode_info?.practice_mode;
    let isPractice = vacation_mode && vacation_mode_info?.practice_mode;
    let isLoggingBodyMetrics = vacation_mode && vacation_mode_info?.log_weekly_body_metrics;

    // Treat legacy vacation mode as paused with no body metrics
    if (vacation_mode === 1 && !vacation_mode_info) {
      isPaused = true;
      isPractice = false;
      isLoggingBodyMetrics = false;
    }

    let alert = false;
    const notTracking = ((threshold_untracked_day_index < daysSinceCheckin) && threshold_untracked_day_index !== null) 
    const warning = (last_progress_summary === "none" || last_progress_summary === "excess" || last_progress_summary === "outside" || check_in_type === 1)
    const late = (daysSinceCheckin > 7) && report_date
    const inactive = (days && days.slice(-14) === 'nnnnnnnnnnnnnn')
    const pending = (claimed === 0)
    const checkin = (daysSinceCheckin === 0)

    // Paused (no body metrics):  All alerts ignored except Pending New User and Checked In Today (if they were not paused then)
    // Paused (log body metrics): Alerts that should be ignored include Incomplete Tracking, Check-In Warrants Examination, and Not Using System
    // Practice (no body metrics): Alerts that should be ignored include Check-in Warrants Examination, Late for Check-In
    // Practice (log body metrics): Alerts that should be ignored include Check-In Warrants Examination

    let shouldIgnoreNotTracking = false;
    let shouldIgnoreWarning = false;
    let shouldIgnoreLate = false;
    let shouldIgnoreInactive = false;

    if (isPaused) {
      if (!isLoggingBodyMetrics) {
        shouldIgnoreNotTracking = true;
        shouldIgnoreWarning = true;
        shouldIgnoreLate = true;
        shouldIgnoreInactive = true;
      } else {
        shouldIgnoreNotTracking = true;
        shouldIgnoreWarning = true;
        shouldIgnoreInactive = true;
      }
    } else if (isPractice) {
      if (!isLoggingBodyMetrics) {
        shouldIgnoreWarning = true;
        shouldIgnoreLate = true;
      } else {
        shouldIgnoreWarning = true;
      }
    }

    if (
      (attentionSettings.tracking && notTracking && !shouldIgnoreNotTracking) ||
      (attentionSettings.warning && warning && !shouldIgnoreWarning) ||
      (attentionSettings.late && late && !shouldIgnoreLate) ||
      (attentionSettings.inactive && inactive && !shouldIgnoreInactive) ||
      (attentionSettings.pending && pending) ||
      (attentionSettings.checkin && checkin)
    ) {
      alert = true;
    }

    return alert;
  };

  const renderTrackingData = (trackingStatus) => {
    let colorMap = {};
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]] = "#f4b300";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]] = "#4cb050";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]] = "#dc544a";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]] = "#1cb09c";

    let toolTextMap = {};
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][1];
    
    return (
      <DarkTooltip
        arrow
        title={
          <TipContent>
            <span style={{fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center', color: colorMap[trackingStatus]}}>{trackingStatus}</span>
            <p>{toolTextMap[trackingStatus]}</p>
          </TipContent>
        }
      >
        <DataCell bold color={colorMap[trackingStatus]}>
          {trackingStatus}
        </DataCell>
      </DarkTooltip>

    )
  };

  const renderLastCheckinData = (data) => {
    const {
      goal,
      check_in_type,
      report_date,
      last_progress_summary,
      last_progress_value,
      weight,
      custom_calories_edit,
      near_period,
      check_in_vacation_mode_info
    } = data;

    const colorKey = {
      "full": "#4cb050",
      "partial": "#f4b300",
      "none": "#dc544a",
      "excess": (goal === "FAT LOSS") ? "#4cb050" : "#dc544a",
      "menstrual": "#181818",
      "sucess": "#4cb050",
      "inside": "#4cb050",
      "outside-below": "#dc544a",
      "outside-above": "#dc544a",
      "improving-below": "#f4b300",
      "improving-above": "#f4b300",
    };

    const lastCheckinDate = (moment.utc(report_date).format('MMM D, YYYY'));

    if (check_in_type === 1) {
      // Non compliaant
      return (
        <LastCheckinCell>
          <DarkTooltip
            arrow
            title={
              <TipContent>
                <p>Out of range of target macros.</p>
              </TipContent>
            }
          >
            <LastCheckinContainer>
              <Bar>
                <div></div>
              </Bar>
              <p>Missed macros</p>
            </LastCheckinContainer>
          </DarkTooltip>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (
      check_in_type === 3 ||
      check_in_type === 4 ||
      check_in_type === 5 ||
      check_in_type === 6 ||
      check_in_type === 7 ||
      check_in_type === 8 ||
      check_in_type === 9
    ) {
      const daysSinceCheckin = getDaysSinceWeighIn(report_date);
      let dayString;

      if (daysSinceCheckin === 0) {
        dayString = "today";
      } else if (daysSinceCheckin === 1) {
        dayString = "yesterday";
      } else {
        dayString = `${daysSinceCheckin} days ago`;
      }

      // Handle grey pill display
      let checkinKey = {
        "3": "Pending: New start",
        "4": "Pending: New user",
        "5": `Left ${(check_in_vacation_mode_info ? check_in_vacation_mode_info?.practice_mode ? "practice" : "pause" : 'vacation')} mode ${dayString}`,
        "6": "Activity level changed",
        "7": "Goal changed",
        "8": "Calories changed",
        "9": "Check-in edited",
      };

      let toolTextMap = "This is why calories changed, prompting a new starting weight to be collected and the next full check-in to be pushed back."
      if(check_in_type === 4) {
        toolTextMap = "No data to show since the client has not yet completed their first check-in on the system."
      } else if (check_in_type === 5) {
        toolTextMap = "Returning from pause or practice mode means the client has started a new check-in cycle and resumed tracking food."
      }

      // Handle calorie change text
      if (check_in_type === 8) {
        if (custom_calories_edit === 3) {
          checkinKey["8"] = 'Calories restored'
        } else {
          checkinKey["8"] = 'Calories edited'
        }
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{toolTextMap}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinPill>
              <p>{checkinKey[check_in_type]}</p>
            </LastCheckinPill>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
      
    } else if (check_in_type === 10 || check_in_type === 11) {
      // Handle reset
      const daysSinceCheckin = getDaysSinceWeighIn(report_date);
      let dayString;

      if (daysSinceCheckin === 0) {
        dayString = "today";
      } else if (daysSinceCheckin === 1) {
        dayString = "yesterday";
      } else {
        dayString = `${daysSinceCheckin} days ago`;
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>This is why calories changed, prompting a new starting weight to be collected and the next full check-in to be pushed back.</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinPill>
              <p>Reset {dayString}</p>
            </LastCheckinPill>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (check_in_type === 12) {
      // Negative number inherently has a negative sign
      let symbol
      let toFixed = 1
      if (last_progress_value > 0) {
        symbol = '+'
      } else if (last_progress_value === 0) {
        toFixed = 0
        if(goal === 'FAT LOSS') {
          symbol = '-'
        } else {
          symbol = '+'
        }
      }
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <p>{(check_in_vacation_mode_info ? check_in_vacation_mode_info?.practice_mode ? "Practice mode" : "Goal paused" : 'vacation')} mode: {symbol}{Number(last_progress_value * 2.204622).toFixed(toFixed)} lbs</p>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (last_progress_summary === "menstrual") {
      // Menstrual
      return (
        <LastCheckinCell>
          <LastCheckinPill>
            <span>Menstrual</span>
          </LastCheckinPill>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (last_progress_summary === "none") {
      let tooltipTextKey = {
        "MUSCLE GAIN": "No weight was gained.",
        "FAT LOSS": "No weight was lost.",
      };
      
      // No Progress
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipTextKey[goal]}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={colorKey[last_progress_summary]} height={100}>
                <div></div>
              </Bar>
              {" "}
              <p>{Math.round(Number(last_progress_value * 100))}% of goal met</p>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (goal === "FAT LOSS") {
      let tooltipFatlossText
      let barColor = colorKey[last_progress_summary]
      let barHeight = Number(last_progress_value * 100)

      if (Number(last_progress_value * 100) === 100) {
        tooltipFatlossText = 'Met weight loss goal.'
      } else if (Number(last_progress_value * 100) === 0 && near_period === 1) {
        tooltipFatlossText = 'No weight was lost, but period was affecting weight.'
        barColor = '#e129a3'
        barHeight = 100
      } else if (Number(last_progress_value * 100) === 0) {
        tooltipFatlossText = 'No weight was lost.'
      } else {
        tooltipFatlossText = 'Partially met weight loss goal.'
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipFatlossText}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={barColor} height={barHeight}>
                <div></div>
              </Bar>
              {" "}
              <p>{Math.round(Number(last_progress_value * 100))}% of goal met</p>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (goal === "MUSCLE GAIN") {
      let tooltipMuscleText
      let barColor = colorKey[last_progress_summary]
      let barHeight = Number(last_progress_value * 100)

      if (last_progress_summary === 'excess') {
        tooltipMuscleText = 'Too much weight was gained.'
      } else if (Number(last_progress_value * 100) === 100) {
        tooltipMuscleText = 'Met muscle gain goal.'
      } else if (Number(last_progress_value * 100) === 0 && near_period === 1) {
        tooltipMuscleText = 'Too much weight was gained, but period was affecting weight.'
        barColor = '#e129a3'
        barHeight = 100
      } else if (Number(last_progress_value * 100) === 0) {
        tooltipMuscleText = 'No weight was gained.'
      } else {
        tooltipMuscleText = 'Partially met muscle gain goal.'
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipMuscleText}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={barColor} height={barHeight}>
                <div></div>
              </Bar>
              {" "}
              {last_progress_summary === "excess" ? 
                <p>Excess gain</p>
                : 
                <p>{Math.round(Number(last_progress_value * 100))}%  of goal met</p>
              }
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
        
      );
    } else if (goal === "REVERSE DIETING") {
      let tipText = "Stayed within weight gain limit"
      let barColor = colorKey[last_progress_summary]
      
      if (last_progress_summary === "excess" && near_period === 1) {
        tipText = "Exceeded weight gain limit, but period was affecting weight"
        barColor = '#e129a3'
      } else if (last_progress_summary === "excess") {
        tipText = "Exceeded weight gain limit."
      }
      
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <Bar color={barColor} height={100}>
              <div></div>
            </Bar>
            {" "}
            <DarkTooltip
              arrow
              title={
                <TipContent>
                  <p>{tipText}</p>
                </TipContent>
              }
            >
              {last_progress_summary === "excess" ? 
                <p>Excess gain</p>
                : 
                <span>{last_progress_summary === "excess" ? "Excess gain" : last_progress_summary}</span>
              }
            </DarkTooltip>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (goal === "MAINTENANCE") {
      const textKey = {
        "inside": "in range",
        "outside-below": "under range",
        "outside-above": "over range",
        "improving-below": "under range",
        "improving-above": "over range",
      };

      const toolTextKey = {
        "inside": "Weighed in within maintenance range.",
        "outside-below": "Weighed in above range, but trending back down.",
        "outside-above": "Weighed in below range, but trending back up.",
        "improving-below": "Weighed in above maintenance range.",
        "improving-above": "Weighed in below maintenance range.",
      };
  
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{toolTextKey[last_progress_summary]}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={colorKey[last_progress_summary]} height={100}>
                <div></div>
              </Bar>
              {" "}
              <span style={{position: 'relative', textTransform: 'none'}}>
                {Math.round(Number(weight * 2.204622))} lbs: {textKey[last_progress_summary]}
                {(last_progress_summary === "improving-below" || last_progress_summary === "improving-above") && <ImprovingText>(improving)</ImprovingText>}
              </span>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else {
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <p>------</p>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    }
  };

  const renderCurrentCheckinData = (data, currentCheckinStatus) => {
    const { daysSinceCheckinDate } = data;

    let status = currentCheckinStatus
    const log_weekly_body_metrics = data.vacation_mode_info?.log_weekly_body_metrics
    if (data.vacation_mode_info && log_weekly_body_metrics) {
      if(daysSinceCheckinDate > 0) {
        status = "Late"
      } else if (daysSinceCheckinDate === 0) {
        status = "Today"
      } else {
        status = "Pending"
      }
    } else if (data.vacation_mode_info && !data.vacation_mode_info?.practice_mode && !log_weekly_body_metrics) {
      status = "Goal paused"
    } else if (data.vacation_mode_info && data.vacation_mode_info?.practice_mode && !log_weekly_body_metrics) {
      status = "Practice mode"
    }

    const colorMap = {
      "Pending": "#f4b300",
      "Today": "#4cb050",
      "Late": "#dc544a",
      // "On vacation": "#5e43c2",
      "Practice mode": "#000000",
      "Goal paused": "#1cb09c"
    };

    const textMap = {
      "Pending": "1 - 7 days into the check-in period",
      "Today": "Checked in earlier today",
      // "On vacation": "Client is on vacation",
      "Practice mode": "Client is in practice mode",
      "Goal paused": "Client is in pause your goal mode"
    }

    if (status === 'Late') {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>Client is late for their current check-in.</p>
            </TipContent>
          }
        >
          <DataCell bold color="#dc544a">
            {daysSinceCheckinDate} {daysSinceCheckinDate > 1 ? 'days' : 'day'} late
          </DataCell>
        </DarkTooltip>
      );
    } else {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{textMap[status]}</p>
            </TipContent>
          }
        >
          <DataCell bold color={colorMap[status]}>
            {status}
          </DataCell>
        </DarkTooltip>
      )
    }
  };

  const renderSortArrows = (isSorting, reverse) => {
    return (
      <div style={{display: 'inline-block', marginLeft: '8px'}}>
        <ArrowsGroup>
          <ArrowUp fill={(isSorting && reverse) ? '#FFFFFF' : '#999999'} />
          <div style={{height: '3px'}}></div>
          <ArrowDown fill={(isSorting && !reverse) ? '#FFFFFF' : '#999999'}/>
        </ArrowsGroup>
      </div>
    )
  }

  const handleSort = (type) => {
    if (type !== sortType.type) {
      setSortType({type: type, reverse: false})
    } else {
      setSortType({type: type, reverse: !sortType.reverse})
    }
  }

  let accounts =_.cloneDeep(user.accounts);
  
  accounts.forEach((entry, index) => {
    //Tracking Status
    const { untracked_day_indices, report_date } = entry;
    const threshold_untracked_day_index = untracked_day_indices.length < attentionSettings.missedtracking ? null : untracked_day_indices[attentionSettings.missedtracking - 1];
    const daysSinceCheckin = getDaysSinceWeighIn(report_date);
    
    if (entry.vacation_mode > 0 && !entry.vacation_mode_info?.practice_mode) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]
    } else if (threshold_untracked_day_index === null || threshold_untracked_day_index > daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]
    } else if (threshold_untracked_day_index === daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]
    } else if (threshold_untracked_day_index < daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]
    }

    const lastWeighInDateTemp = new Date(entry.report_date)
    const lastWeighInDate = new Date(lastWeighInDateTemp.getUTCFullYear(), lastWeighInDateTemp.getUTCMonth(), lastWeighInDateTemp.getUTCDate())
    let userCheckinDate = hostDateToString(lastWeighInDate)
    userCheckinDate = dateStringAddDays(userCheckinDate, 7)
    const lastWeighInDatePlus5Days = new Date(lastWeighInDate.getFullYear(), lastWeighInDate.getMonth(), lastWeighInDate.getDate() + 5)
    const nextPossibleWeighInDate = new Date(lastWeighInDatePlus5Days.valueOf())
    let desiredDayOfWeek = null

    if (entry.check_in_date) {
      const checkInDateTemp = new Date(entry.check_in_date);
      const checkInDate = new Date(
        checkInDateTemp.getUTCFullYear(),
        checkInDateTemp.getUTCMonth(),
        checkInDateTemp.getUTCDate()
      );
      desiredDayOfWeek = checkInDate.getDay()
      let dayOffset = desiredDayOfWeek - nextPossibleWeighInDate.getDay()
      if(dayOffset < 0) {
        dayOffset += 7
      }
      const desiredNextWeighInDate = new Date(nextPossibleWeighInDate.getFullYear(), nextPossibleWeighInDate.getMonth(), nextPossibleWeighInDate.getDate() + dayOffset)
      userCheckinDate = hostDateToString(desiredNextWeighInDate);
    }
    
    const daysSinceCheckinDate = getDaysSinceWeighIn(userCheckinDate);
    accounts[index].daysSinceCheckinDate = daysSinceCheckinDate

    //Current Check-in Status
    if (entry.vacation_mode > 0) {
      accounts[index].currentCheckinStatus = "Goal paused"
    } else if (daysSinceCheckin === 0) {
      accounts[index].currentCheckinStatus = "Today"
    } else if (daysSinceCheckinDate > 0) {
      accounts[index].currentCheckinStatus = "Late"
    } else {
      accounts[index].currentCheckinStatus = "Pending"
    }
  })

  accounts.sort((a, b) => {
    if (sortType.type === 'currentCheckinStatus') {
      const AdaysSinceCheckin = getDaysSinceWeighIn(a.report_date);
      const BdaysSinceCheckin = getDaysSinceWeighIn(b.report_date);

      if(AdaysSinceCheckin < BdaysSinceCheckin ) { return -1; }
      if(AdaysSinceCheckin > BdaysSinceCheckin ) { return 1; }
      return 0;
    } else {
      if(a[sortType.type] < b[sortType.type]) { return -1; }
      if(a[sortType.type] > b[sortType.type]) { return 1; }
      return 0;
    }
  })

  if (sortType.reverse) {
    accounts.reverse();
  }

  return (
    <Container>
      <TitleContainer>
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>For a client to appear in this table, one of these criteria must be met.</p>
              <div style={{height: '8px'}}></div>
              <li>Incomplete tracking this period</li>
              <li>Poor progress or missed macros last check-in</li>
              <li>Late for the current check-in</li>
              <li>Checked in today (if selected in Set Parameters)</li>
            </TipContent>
          }
        >
          <TableTitle>Clients in need of attention</TableTitle>
        </DarkTooltip>
        <AlertSettings />
      </TitleContainer>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell bigWidth onClick={() => handleSort('name')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <p>Name</p> 
                  {renderSortArrows((sortType.type === 'name'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell onClick={() => handleSort('trackingStatus')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows how consistently food is being logged during this check-in period:</p>
                        <div style={{height: '8px'}}></div>
                        <li><span style={{color: '#4cb050'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][1]}</li>
                        <li><span style={{color: '#f4b300'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][1]}</li>
                        <li><span style={{color: '#dc544a'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][1]}</li>
                        <li><span style={{color: '#1cb09c'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][1]}</li>
                      </TipContent>
                    }
                  >
                    <p>Tracking</p> 
                  </DarkTooltip>
                  {renderSortArrows((sortType.type === 'trackingStatus'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell bigWidth>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <DarkTooltip DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows the results of the last full check-in. If a major setting was changed that affected calories after the last check-in day, that is shown instead.</p>
                      </TipContent>
                    }
                  >
                    <p>Last check-in</p>
                  </DarkTooltip>
                </div>
              </HeadCell>

              <HeadCell bigWidth onClick={() => handleSort('currentCheckinStatus')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows where the client is at in their current check-in period:</p>
                        <div style={{height: '8px'}}></div>
                        <li><span style={{color: '#4cb050'}}>Today</span> = Checked in earlier today</li>
                        <li><span style={{color: '#f4b300'}}>Pending</span> = 1 - 7 days into the check-in period</li>
                        <li><span style={{color: '#dc544a'}}>Late</span> = 8+ days into the check-in period</li>
                        {/* <li><span style={{color: '#5e43c2'}}>On vacation</span> = Client is on vacation</li> */}
                        <li><span style={{color: '#FFF'}}>Practice mode</span> = Client is on practice mode</li>
                        <li><span style={{color: '#1cb09c'}}>Goal paused</span> = Client is on pause your goal mode</li>                      </TipContent>
                    }
                  >
                    <p>Current check-in</p> 
                  </DarkTooltip>
                  {renderSortArrows((sortType.type === 'currentCheckinStatus'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell style={{textAlign: 'center', width: '130px'}}>Actions</HeadCell>
              </TableHeadRow>
          </TableHead>
          <TableBody>
            {accounts.map((entry, index) => {
              const qualifying = (filterGroupID === 0 || entry.groups.includes(filterGroupID)) && (clientsTrainerID === '' || entry.trainers.includes(clientsTrainerID))
              if (entry.report_date) {
                if (
                  entry.trainer_permission &&
                  entry.claimed === 1 &&
                  qualifying &&
                  isAlert(entry)
                ) {
                  return (
                    <TableBodyRow key={entry.id}>
                      <NameCell nearPeriod={entry.near_period}>
                        <DarkTooltip 
                          title={
                            <TipContent>
                              <p>{entry.name}</p>
                              {entry.near_period === 1 && <p style={{color: '#ffbbe8'}}>Client’s weight is being affected by their menstrual cycle</p>}
                            </TipContent>
                          }
                          arrow
                        >
                          <span>
                            {entry.near_period === 1 && (
                              <img src={RefreshIcon} alt="icon" />
                            )}{" "}
                              {entry.name}
                          </span>
                        </DarkTooltip>
                      </NameCell>
                      {renderTrackingData(entry.trackingStatus)}

                      {renderLastCheckinData(entry)}

                      {renderCurrentCheckinData(entry, entry.currentCheckinStatus)}
                      <DataCell>
                        <Row style={{justifyContent: 'center'}}>
                          <Action
                            icon={<SearchIcon />}
                            text="Inspect"
                            onClick={() => {
                              props.history.push(
                                "/dashboard/inspect/" + entry.id + "/overview"
                              );
                            }}
                          />
                        </Row>
                      </DataCell>
                    </TableBodyRow>
                  );
                } 
              } else {
                if (
                  isAlert(entry) &&
                  qualifying
                ) {
                  return (
                    <TableBodyRow key={entry.id}>
                      <DataCell colSpan="7">
                        <div style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
                          <DarkTooltip 
                            title={
                              <TipContent>
                                <p>{entry.name}</p>
                              </TipContent>
                            }
                            arrow
                          >
                            <NameText>{entry.name}</NameText>
                          </DarkTooltip>
                          <p style={{ color: '#898989', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>User has not set up their profile.</p>
                        </div>
                      </DataCell>
                    </TableBodyRow>
                  )
                }
              }
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default withRouter(AccountsTable);
